import { memo, useCallback } from 'react'
import { Paper } from '@mui/material'
import { Stack, UserInfo } from '@collaborate-health/uikit'
import SearchResultButton from '../SearchResultButton'

interface User {
  Id: number
  Name: string
  Email: string
  AvatarUrl: string
}

interface UserSearchResultItemProps {
  user: User
  button: string
  handleButtonClick: (user: User) => void
}

const UserSearchResultItem: React.FC<UserSearchResultItemProps> = ({ user, button, handleButtonClick }) => {
  const _handleClick = useCallback(() => {
    handleButtonClick(user)
  }, [handleButtonClick, user])

  return (
    <Paper variant='outlined'>
      <Stack direction='row' alignItems='center' justifyContent='space-between' p={0.5}>
        <UserInfo item={user} />
        <SearchResultButton button={button} handleButtonClick={_handleClick} />
      </Stack>
    </Paper>
  )
}

export default memo(UserSearchResultItem)

